export default __webpack_public_path__ + "static/octosign-example2-7c6edf59f1ca24b7703913c74dcc6034.png";